import {
  DataNode,
  Device,
  DeviceAux,
  DeviceEut,
  DeviceEutGroup,
  DeviceType,
  NodeDataType,
} from "graphql/types"

export const isNodeTable = (node: DataNode) => {
  return node.dataType === NodeDataType.TABLE
}

export const isNodeImage = (node: DataNode) => {
  return node.dataType === NodeDataType.IMAGE
}

export const isNodeText = (node: DataNode) => {
  return node.dataType === NodeDataType.TEXT
}

export const isDeviceTe = (device: Device) => {
  return device.type === DeviceType.TEST_EQUIPMENT
}

export const isDeviceEut = (device: Device): device is DeviceEut => {
  return device.type === DeviceType.EQUIPMENT_UNDER_TEST
}

export const isEutGroup = (device: Device): device is DeviceEutGroup => {
  // Check both type and __typename for better reliability
  const hasCorrectType = device.type === DeviceType.EUT_GROUP
  const hasCorrectTypename = (device as any).__typename === 'DeviceEutGroup'
  
  // Log for debugging
  if (hasCorrectTypename && !hasCorrectType) {
    console.warn('Device has __typename DeviceEutGroup but wrong type:', {
      id: device.id,
      name: device.name,
      type: device.type,
      __typename: (device as any).__typename
    })
  }
  
  return hasCorrectType || hasCorrectTypename
}

export const isDeviceAux = (device: Device): device is DeviceAux => {
  return device.type === DeviceType.AUX
}

export const isDeviceConsumable = (device: Device) => {
  return device.type === DeviceType.CONSUMABLE
}
